import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const EmergencyPanel = ({ onEscalate, helperMode = false }) => {
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [escalationType, setEscalationType] = useState(null);

  const crisisResources = [
    {
      id: 'suicide-prevention',
      name: 'National Suicide Prevention Lifeline',
      phone: '988',
      description: '24/7 crisis support for suicidal thoughts',
      icon: 'Phone',
    },
    {
      id: 'crisis-text',
      name: 'Crisis Text Line',
      phone: 'Text HOME to 741741',
      description: 'Text-based crisis support',
      icon: 'MessageSquare',
    },
    {
      id: 'emergency',
      name: 'Emergency Services',
      phone: '911',
      description: 'Immediate life-threatening emergencies',
      icon: 'AlertTriangle',
    },
  ];

  const handleEscalate = (type) => {
    setEscalationType(type);
    setShowConfirmation(true);
  };

  const confirmEscalation = () => {
    onEscalate(escalationType);
    setShowConfirmation(false);
  };

  return (
    <>
      <div className="absolute top-20 right-4 w-80 bg-card border border-border rounded-lg shadow-xl p-4 z-50">
        <div className="flex items-center gap-2 mb-4">
          <div className="w-8 h-8 rounded-full bg-error/10 flex items-center justify-center">
            <Icon name="AlertCircle" size={20} className="text-error" />
          </div>
          <h3 className="text-base font-semibold text-foreground">
            Emergency Resources
          </h3>
        </div>

        <div className="space-y-3 mb-4">
          {crisisResources?.map((resource) => (
            <div
              key={resource?.id}
              className="p-3 bg-muted rounded-lg hover:bg-muted/80 transition-colors cursor-pointer"
              onClick={() => window.open(`tel:${resource?.phone?.replace(/\D/g, '')}`)}
            >
              <div className="flex items-start gap-3">
                <Icon name={resource?.icon} size={20} className="text-error mt-0.5" />
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-medium text-foreground">
                    {resource?.name}
                  </p>
                  <p className="text-sm text-primary font-mono mt-1">
                    {resource?.phone}
                  </p>
                  <p className="text-xs text-muted-foreground mt-1">
                    {resource?.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {helperMode && (
          <div className="pt-4 border-t border-border space-y-2">
            <p className="text-xs text-muted-foreground mb-3">
              Helper Duty of Care Protocols
            </p>
            <Button
              variant="destructive"
              size="sm"
              iconName="AlertTriangle"
              iconPosition="left"
              fullWidth
              onClick={() => handleEscalate('immediate')}
            >
              Escalate to Emergency Services
            </Button>
            <Button
              variant="outline"
              size="sm"
              iconName="UserCheck"
              iconPosition="left"
              fullWidth
              onClick={() => handleEscalate('supervisor')}
            >
              Contact Supervisor
            </Button>
          </div>
        )}
      </div>
      {/* Escalation Confirmation Modal */}
      {showConfirmation && (
        <div className="fixed inset-0 z-[1000] flex items-center justify-center bg-black/50 backdrop-blur-sm">
          <div className="bg-card rounded-lg shadow-xl max-w-md w-full mx-4 p-6">
            <div className="flex items-start gap-3 mb-4">
              <div className="w-10 h-10 rounded-full bg-error/10 flex items-center justify-center flex-shrink-0">
                <Icon name="AlertTriangle" size={20} className="text-error" />
              </div>
              <div>
                <h3 className="text-lg font-semibold text-foreground mb-2">
                  Confirm Emergency Escalation
                </h3>
                <p className="text-sm text-muted-foreground">
                  {escalationType === 'immediate' ?'This will immediately alert emergency services and end the current session. Use only for life-threatening situations.' :'This will notify your supervisor and request immediate assistance while maintaining the session.'}
                </p>
              </div>
            </div>
            <div className="flex items-center gap-3">
              <Button
                variant="outline"
                fullWidth
                onClick={() => setShowConfirmation(false)}
              >
                Cancel
              </Button>
              <Button
                variant="destructive"
                fullWidth
                onClick={confirmEscalation}
              >
                Confirm Escalation
              </Button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default EmergencyPanel;